import React, { useState, useRef } from 'react';

export default function ProductImageZoom({ src, alt }) {
    const [isHovered, setIsHovered] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const containerRef = useRef(null);

    const handleMouseMove = (e) => {
        if (!containerRef.current) return;

        const { left, top, width, height } = containerRef.current.getBoundingClientRect();

        // Calculate percentage position
        let x = ((e.clientX - left) / width) * 100;
        let y = ((e.clientY - top) / height) * 100;

        // Clamp values between 0 and 100
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));

        setPosition({ x, y });
    };

    return (
        <div
            className="relative w-full h-full overflow-hidden cursor-zoom-in bg-white flex items-center justify-center p-4"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onMouseMove={handleMouseMove}
            ref={containerRef}
        >
            {/* Original Image - Hidden on hover to show zoomed version seamlessly, 
                or kept visible if we use a side-by-side. 
                For inner zoom, we overlay the zoomed background.
            */}
            <img
                src={src}
                alt={alt}
                className={`max-w-full max-h-full object-contain transition-opacity duration-200 ${isHovered ? 'opacity-0' : 'opacity-100'}`}
            />

            {/* Zoom Overlay */}
            {isHovered && (
                <div
                    className="absolute inset-0 pointer-events-none"
                    style={{
                        backgroundImage: `url(${src})`,
                        backgroundPosition: `${position.x}% ${position.y}%`,
                        backgroundSize: '200%', // 2x Zoom level
                        backgroundRepeat: 'no-repeat',
                        // Ensuring the background respects object-contain is tricky with CSS background.
                        // We assume standard product images. If they are highly irregular, 
                        // background-size might need 'contain' which defeats zoom, or careful sizing.
                        // Setting a fixed backgroundSize is standard for this effect.
                    }}
                />
            )}
        </div>
    );
}
